// extracted by mini-css-extract-plugin
export default {"advertWrapper":"YUSQ-iIO","advert":"iFQU7SOv","placeholder":"AdUnit_placeholder__nNOi2bEu","background":"AdUnit_background__eOsR2aPX","content":"AdUnit_content__XWyUyI9W"};